module.exports = __webpack_public_path__ + "assets/img/voice-collect.bc14dc6f.gif";